import { fetchAuthSession } from 'aws-amplify/auth'
import axios from 'axios';
import apiurl from "./apiweb.js"
// import FileDownload from 'js-file-download';

const obj = {
    getPermissions: async (params) =>
    axios({
        'method':'GET',
        'url':apiurl + "/userpermissions",
        'headers': {
            'content-type':'application/json',
            'Authorization':"Bearer " + (await fetchAuthSession()).tokens?.idToken?.toString()
        },
        'crossdomain': true,
        'params': {
            ...params
        },
    })
};

export default obj;